/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChatLlmResponseDto } from '../models/chat-llm-response-dto';
import { llmControllerAbortLlmCall } from '../fn/llm/llm-controller-abort-llm-call';
import { LlmControllerAbortLlmCall$Params } from '../fn/llm/llm-controller-abort-llm-call';
import { llmControllerChatLlm } from '../fn/llm/llm-controller-chat-llm';
import { LlmControllerChatLlm$Params } from '../fn/llm/llm-controller-chat-llm';
import { llmControllerChatLlmStreaming } from '../fn/llm/llm-controller-chat-llm-streaming';
import { LlmControllerChatLlmStreaming$Params } from '../fn/llm/llm-controller-chat-llm-streaming';
import { llmControllerGetProviderList } from '../fn/llm/llm-controller-get-provider-list';
import { LlmControllerGetProviderList$Params } from '../fn/llm/llm-controller-get-provider-list';
import { LlmProviderInfo } from '../models/llm-provider-info';

@Injectable({ providedIn: 'root' })
export class LlmService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `llmControllerGetProviderList()` */
  static readonly LlmControllerGetProviderListPath = '/llm/providerList';

  /**
   * Get the list of supported llm providers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmControllerGetProviderList()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmControllerGetProviderList$Response(params?: LlmControllerGetProviderList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmProviderInfo>>> {
    const obs = llmControllerGetProviderList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the list of supported llm providers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmControllerGetProviderList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmControllerGetProviderList(params?: LlmControllerGetProviderList$Params, context?: HttpContext): Observable<Array<LlmProviderInfo>> {
    const resp = this.llmControllerGetProviderList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<LlmProviderInfo>>): Array<LlmProviderInfo> => r.body)
    );
  }

  /** Path part for operation `llmControllerChatLlm()` */
  static readonly LlmControllerChatLlmPath = '/llm/{ilsId}/chatLlm';

  /**
   * Make a call to a llm using lang chain.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmControllerChatLlm()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  llmControllerChatLlm$Response(params: LlmControllerChatLlm$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatLlmResponseDto>> {
    const obs = llmControllerChatLlm(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Make a call to a llm using lang chain.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmControllerChatLlm$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  llmControllerChatLlm(params: LlmControllerChatLlm$Params, context?: HttpContext): Observable<ChatLlmResponseDto> {
    const resp = this.llmControllerChatLlm$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ChatLlmResponseDto>): ChatLlmResponseDto => r.body)
    );
  }

  /** Path part for operation `llmControllerChatLlmStreaming()` */
  static readonly LlmControllerChatLlmStreamingPath = '/llm/{ilsId}/stream';

  /**
   * Make a call to a llm using lang chain and expect a streaming result.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmControllerChatLlmStreaming()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  llmControllerChatLlmStreaming$Response(params: LlmControllerChatLlmStreaming$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = llmControllerChatLlmStreaming(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Make a call to a llm using lang chain and expect a streaming result.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmControllerChatLlmStreaming$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  llmControllerChatLlmStreaming(params: LlmControllerChatLlmStreaming$Params, context?: HttpContext): Observable<void> {
    const resp = this.llmControllerChatLlmStreaming$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmControllerAbortLlmCall()` */
  static readonly LlmControllerAbortLlmCallPath = '/llm/{abortId}/abortStream';

  /**
   * Abort a streaming call to a llm.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmControllerAbortLlmCall()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmControllerAbortLlmCall$Response(params: LlmControllerAbortLlmCall$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = llmControllerAbortLlmCall(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Abort a streaming call to a llm.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmControllerAbortLlmCall$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmControllerAbortLlmCall(params: LlmControllerAbortLlmCall$Params, context?: HttpContext): Observable<void> {
    const resp = this.llmControllerAbortLlmCall$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
